"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { withLocalePrefix } from "@/lib/i18nRouting";

type Props = Omit<ComponentProps<typeof Link>, "href"> & { href: string };

/** Internal navigation that respects Arabic (no prefix) vs English (`/en`). */
export function LocaleLink({ href, ...rest }: Props) {
  const { locale } = useLanguage();
  return <Link href={withLocalePrefix(locale, href)} {...rest} />;
}
